import { toRefs, ref, computed } from 'vue';
import RatioBox from '../ratio-box/component-lib.esm.js';
import { useResizeObserver } from '../../compositions/component-lib.esm7.js';

//
var script = {
  name: 'Preview',
  components: {
    RatioBox
  },
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const {
      width,
      height
    } = toRefs(props);
    const wrapper = ref(null);
    const container = ref(null);
    const scale = ref('');
    function update() {
      if (!container.value) return;
      const cw = width.value;
      const ch = height.value;
      let {
        width: ww,
        height: wh
      } = container.value.$el.getBoundingClientRect();
      let scaleAmtX = Math.min(ww / cw, wh / ch);
      let scaleAmtY = scaleAmtX;
      scale.value = `scale(${scaleAmtX.toFixed(3)}, ${scaleAmtY.toFixed(3)}`;
    }

    // CSS transform scale the child element to fit in the parent element
    const styles = computed(() => {
      return {
        '--c-scale': scale.value
      };
    });
    const classes = computed(() => {
      return {
        'v-scaled-device--scaled': scale.value
      };
    });
    useResizeObserver(wrapper, update);
    return {
      wrapper,
      container,
      styles,
      classes
    };
  }
};
export { script as default };